import { useMutation, useQuery } from "react-query";
import http from "shared/http";

export interface PendingUser {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  requestType?: string;
  agencies?: string | string[];
  roles?: string | string[];
  isApproved?: boolean;
  reason?: string;
  externalSystemId?: string;
  payee?: string;
  authProvider?: string;
  company?: string;
  updatedBy?: string;
  updatedAt?: Date;
  createdAt?: Date;
}

export interface PendingUserMatch {
  id: number;
  firstname: string | null;
  lastname: string | null;
  email: string | null;
  phone: string | null;
  driverType: string | null;
  isActive: boolean | null;
  externalSystemId: string | null;
  externalSystem: string | null;
  payee: string | null;
  agencyId: number | null;
  agencyName: string | null;
  agencyCode: string | null;
  companyId: number | null;
}

export const usePendingUserMatchesQuery = (
  pendingUserId: number | undefined,
  enabled: boolean,
) =>
  useQuery(
    ["pending-user-matches", pendingUserId],
    async (): Promise<PendingUserMatch[]> => {
      const response: PendingUserMatch[] = await http.fetchAsync(
        `admin/pending-users/${pendingUserId}/matches`,
      );
      return response;
    },
    { enabled: enabled && pendingUserId !== undefined },
  );

export interface CreatePendingUserRequest {
  firstname: string;
  lastname: string;
  email: string;
  requestType: string;
  agencies?: string[];
  externalSystemId?: string;
  company?: string;
}

export const useCreatePendingUserMutation = () => {
  return useMutation(async (request: CreatePendingUserRequest) => {
    const response = await http.postAsync("users/pending-users", request);
    return response;
  });
};

export const useUpsertPendingUserMutation = () => {
  return useMutation(async (pendingUser: PendingUser) => {
    const response = await http.putAsync(
      `admin/pending-users/${pendingUser.id}`,
      pendingUser,
    );
    return response;
  });
};

export const useAgencyManagerUpsertPendingUserMutation = () => {
  return useMutation(async (pendingUser: PendingUser) => {
    const response = await http.putAsync(
      `agencymanager/pending-users/${pendingUser.id}`,
      pendingUser,
    );
    return response;
  });
};
